import React, { Component } from "react";
import ReactHtmlParser from "react-html-parser";
import Anchor from "./pageElements/anchor";

class flexText extends Component {
  constructor(props) {
    super(props);
    this.state = {
      size: "50px",
      lineHeight: ""
    };
  }

  static defaultProps = {
    max: 50,
    min: 50,
    pert: 0.25,
    className: "flexText",
    tag: "p",
    backgroundColor: "transparent",
    styles: {
      boxSize: "borderBox"
    },
    children: null,
    container: "App",
    blockStyles: { boxSizing: "border-box" }
  };

  updateFontSize() {
    let max = 50;
    let min = 50;
    let pert = 0.042;

    if (this.props.max && this.props.min) {
      max = this.props.max;
      min = this.props.min;
    }
    if (this.props.pert) {
      pert = this.props.pert;
    }
    const width = document.getElementsByClassName(this.props.container)[0]
      .parentElement.offsetWidth;

    let new_size = width * pert;
    let lineHeight = new_size * 1.5;
    if (new_size < max && new_size >= min) {
      new_size = new_size + "px";
      lineHeight = new_size * 1.5 + "px";
    } else if (new_size < min) {
      new_size = min + "px";
      lineHeight = min * 1.5 + "px";
    } else {
      new_size = max + "px";
      lineHeight = max * 1.5 + "px";
    }
    this.setState({ size: new_size, lineHeight: lineHeight });
  }

  /**
   * Add event listener
   */
  componentDidMount() {
    this.updateFontSize();
    window.addEventListener("resize", this.updateFontSize.bind(this));
  }

  /**
   * Remove event listener
   */

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateFontSize.bind(this));
  }

  render() {
    let children = ReactHtmlParser(this.props.children);
    const { id, className, color, url, styles, blockStyles } = this.props;
    if (typeof url !== "undefined") {
      children = (
        <Anchor id={id + "_link"} href={url}>
          {children}
        </Anchor>
      );
    }
    const lineHeight = this.state.lineHeight;
    return (
      <div style={blockStyles}>
        {this.props.tag === "h1" ? (
          <h1
            className={"flexText " + className}
            id={id}
            style={{
              color: color,
              fontSize: this.state.size,
              lineHeight: lineHeight,
              ...styles
            }}
          >
            {children}
          </h1>
        ) : this.props.tag === "h2" ? (
          <h2
            className={"flexText " + className}
            id={id}
            style={{
              color: color,
              fontSize: this.state.size,
              lineHeight: lineHeight,
              ...styles
            }}
          >
            {children}
          </h2>
        ) : this.props.tag === "h3" ? (
          <h3
            className={"flexText " + className}
            id={id}
            style={{
              color: color,
              fontSize: this.state.size,
              lineHeight: lineHeight,
              ...styles
            }}
          >
            {children}
          </h3>
        ) : this.props.tag === "h4" ? (
          <h4
            className={"flexText " + className}
            id={id}
            style={{
              color: color,
              fontSize: this.state.size,
              lineHeight: lineHeight,
              ...styles
            }}
          >
            {children}
          </h4>
        ) : this.props.tag === "h5" ? (
          <h5
            className={"flexText " + className}
            id={id}
            style={{
              color: color,
              fontSize: this.state.size,
              lineHeight: lineHeight,
              ...styles
            }}
          >
            {children}
          </h5>
        ) : this.props.tag === "h6" ? (
          <h6
            className={"flexText " + className}
            id={id}
            style={{
              color: color,
              fontSize: this.state.size,
              lineHeight: lineHeight,
              ...styles
            }}
          >
            {children}
          </h6>
        ) : this.props.tag === "div" ? (
          <div
            className={"flexText " + className}
            id={id}
            style={{
              color: color,
              fontSize: this.state.size,
              lineHeight: lineHeight,
              ...styles
            }}
          >
            {children}
          </div>
        ) : this.props.tag === "span" ? (
          <span
            className={"flexText " + className}
            id={id}
            style={{
              color: color,
              fontSize: this.state.size,
              lineHeight: lineHeight,
              ...styles
            }}
          >
            {children}
          </span>
        ) : this.props.tag === "li" ? (
          <li
            className={"flexText " + className}
            id={id}
            style={{
              color: color,
              fontSize: this.state.size,
              lineHeight: lineHeight,
              ...styles
            }}
          >
            {children}
          </li>
        ) : this.props.tag === "ul" ? (
          <ul
            className={"flexText " + className}
            id={id}
            style={{
              color: color,
              fontSize: this.state.size,
              lineHeight: lineHeight,
              ...styles
            }}
          >
            {children}
          </ul>
        ) : (
          <span
            className={"flexText " + className}
            id={id}
            style={{
              color: color,
              fontSize: this.state.size,
              lineHeight: lineHeight,
              ...styles
            }}
          >
            {children}
          </span>
        )}
      </div>
    );
  }
}

export default flexText;
